import React from 'react';
import styles from './style.module.css';
import StepTwoForm from '../../components/forms/step-two';
import InfoBox from '../../../../common/components/info-box';

const tooltip = {
    title: 'What do I want in the future?',
    content: <span>Maybe you already have a clear path and maybe you don't. Reflecting on the questions above can help you discover more about what's important to you.</span>
};

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>My Prosperity Planner</p>
        <h1 className={styles.mainTitle}>Starting Points</h1>
        <p className={styles.text}>Let’s begin your prosperity conversation with what’s most important to you. Think about your future and describe what it looks like in these areas.</p>
        <StepTwoForm />
        <InfoBox
            title={tooltip.title}
            content={tooltip.content}
        />
    </div>
);
